<footer class="bg-age-footer py-2 text-center mt-8">
  <div class="container mx-auto px-4 flex flex-col items-center">
    <h3 class="font-bebas text-xl text-age-primary mb-2 uppercase">
      16<sup>ème</sup> Rencontres Nationales de Gérontologie
    </h3>
    <p class="text-xs md:text-sm text-age-primary mb-2 font-semibold">
      Du jeudi 21 au samedi 23 mai 2026 • Casablanca, Maroc
    </p>
    <div class="w-200 h-[1px] bg-[#57534E4D] mb-2"></div>
    <small
      class="text-[10px] uppercase tracking-tighter text-age-primary font-bold"
    >
      © 2026 1of1Events. Tous droits réservés.
    </small>
  </div>
</footer>
